import { render } from "./privacy.vue?vue&type=template&id=4cdb2327&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"

import "./privacy.vue?vue&type=style&index=0&id=4cdb2327&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdb2327"]])

export default __exports__